<template>
	<div id="echarts-border" :class="{ onlyOne: onlyOne }">
		<div class="border-header">
			<div class="header-logo" ref="logo" :class="{ doubleSize }"></div>
			<div class="header-title">
				<span
					class="goToLink"
					:class="{ fromChildren: children, canClick: link }"
					@click.stop="linkTo"
					>{{ title }}<span v-if="link">&nbsp;></span></span>
				<el-popover
					placement="bottom-start"
					:title="popoverTitle"
					width="200"
					trigger="hover"
					:content="popoverContent"
					v-if="popoverTitle"
					class="img-popver"
					popper-class="el_popover_class"
				>
					<div class="img-wapper" slot="reference">
						<img src="@/assets/image/echartsBorder/about.svg" />
					</div>
				</el-popover>
			</div>
			<div class="select" :class="{ class2: from == 2 }">
				<slot name="select"></slot>
			</div>
			<div class="link">
				<slot name="link"></slot>
			</div>
		</div>
		<div class="border-main">
			<slot name="main"></slot>
		</div>
	</div>
</template>
<script>
import { mapState } from 'vuex'

import logoImg1 from '@/assets/image/echartsBorder/echarts_icon_1.svg'
import logoImg2 from '@/assets/image/echartsBorder/echarts_icon_2.svg'
import logoImg3 from '@/assets/image/echartsBorder/echarts_icon_3.svg'
import logoImg4 from '@/assets/image/echartsBorder/echarts_icon_4.svg'
import logoImg5 from '@/assets/image/echartsBorder/echarts_icon_5.svg'
import logoImg6 from '@/assets/image/echartsBorder/echarts_icon_6.svg'
import logoImg7 from '@/assets/image/echartsBorder/personal.png'
import logoImg8 from '@/assets/image/echartsBorder/resetPassword.png'
import logoImg9 from '@/assets/image/echartsBorder/cancelAccount.png'
import logoImg10 from '@/assets/image/echartsBorder/echarts_icon_10.png'
export default {
  props: ['title', 'logoImgType', 'popoverTitle', 'popoverContent', 'from', 'onlyOne', 'canClick', 'link', 'children'],
  data() {
    return {
      visible: false,
      logoImg: '',
      doubleSize: false
    }
  },
  mounted() {
    this.initLogoBg()
  },
  methods: {
    initLogoBg() {
      let imgsrc
      switch (this.logoImgType) {
        case '1':
          imgsrc = logoImg1
          break
        case '2':
          imgsrc = logoImg2
          break
        case '3':
          imgsrc = logoImg3
          break
        case '4':
          imgsrc = logoImg4
          break
        case '5':
          imgsrc = logoImg5
          break
        case '6':
          imgsrc = logoImg6
          break
        case '7':
          this.doubleSize = true
          imgsrc = logoImg7
          break
        case '8':
          this.doubleSize = true
          imgsrc = logoImg8
          break
        case '9':
          this.doubleSize = true
          imgsrc = logoImg9
          break
        case '10':
          this.doubleSize = true
          imgsrc = logoImg10
          break
        default:
          imgsrc = logoImg1
      }
      this.$refs.logo.style.backgroundImage = `url(${imgsrc})`
    },
    linkTo() {
      if (this.link) {
        //判断是否可以点进去
        //判断是否是会员
        if (!this.is_login) {
          //未登录先登录
          sessionStorage.setItem('goToMember', true) // 存session，是为了退出登录跳转到首页之后，弹出登录弹窗
          sessionStorage.setItem('memberLink', this.link) // 存session，是为了退出登录跳转到首页之后，弹出登录弹窗
          this.$loginDialog.open()
        }
        if (this.is_member && this.is_login) {
          this.$router.push(this.link)
        }
        if (!this.is_member && this.is_login) {
          this.$msgBox
            .showMsgBox({
              content: '开通测速网大数据会员，可查看近3个月平台页面展示的所有数据',
              cancelVal: '我再想想',
              confirmVal: '立即开通'
            })
            .then(async val => {
              // ...
              this.$router.push({ path: '/pay-member' })
            })
            .catch(() => {
              // ...
              console.log('取消')
            })
        }
      }
    }
  },
  computed: {
    ...mapState('login', ['is_login', 'is_member'])
  }
}
</script>
<style lang="less">
	#echarts-border {
		width: 100%;
		height: 100%;
		&.onlyOne {
			.border-header {
				.select {
					right: 10px;
					.my-select {
						width: 0.8rem;
					}
				}
			}
		}

		.border-header {
			width: 100%;
			height: 0.36rem;
			background: linear-gradient(180deg, #002256 0%, #001339 100%);
			border-radius: 0.08rem 0.08rem 0px 0px;
			position: relative;

			& > div {
				float: left;
			}

			.header-logo {
				width: 0.4rem;
				height: 0.36rem;
				background-color: #296eb1;
				border-radius: 8px 0px 0px 0px;
				background-position: 50% 50%;
				background-repeat: no-repeat;
				&.doubleSize {
					background-size: 50%;
				}
			}

			.header-title {
				height: 0.36rem;
				line-height: 0.36rem;
				display: inline-block;
				padding: 0 0.05rem 0 0.17rem;
				font-size: 0.18rem;
				font-weight: 500;
				color: #ffffff;
				background: #003861;
				position: relative;

				&::after {
					content: '';
					display: inline-block;
					font-size: 12px;
					width: 0.21rem;
					height: 0.36rem;
					background: url(@/assets/image/echartsBorder/delta.png) no-repeat;
					background-size: 100% 100%;
					position: absolute;
					right: -0.2rem;
				}

				.delta {
					width: 0.21rem;
					height: 0.36rem;
					background: url(@/assets/image/echartsBorder/delta.png) no-repeat;
					background-size: 0.21rem 0.36rem;
					position: absolute;
				}
			}

			.select {
				float: right;
				padding-right: 0.1rem;
				position: absolute;
				right: 0;

				&.class2 {
					right: 0px;
					padding-right: 0;

					.my-select:first-child {
						width: 0.8rem;
					}

					.my-select:last-child {
						width: 0.8rem;
					}
				}
			}

			.link {
				height: 0.36rem;
				font-size: 11px;
				font-weight: 500;
				color: #ffffff;
				line-height: 0.36rem;
				float: right;
				margin-right: 19px;
				span {
					display: inline-block;
				}
			}
		}

		.border-main {
			width: 100%;
			height: calc(100% - 0.36rem);
			background-color: #060f2b;
			position: relative;
			border-radius: 0px 0px 6px 6px;
			//overflow: hidden;
		}

		.img-popver {
			height: 100%;
			display: inline-block;
			cursor: pointer;
			position: relative;

			span {
				display: inline-block;
				width: 0.2rem;
				height: 0.16rem;
			}
      .el-popover__reference-wrapper {
        height: 100%;
      }

			img {
				position: absolute;
				top: 50%;
				transform: translateY(-50%);
			}
		}

		.goToLink {
			// height: 22px;
			// font-size: 14px;
			// font-weight: 500;
			// color: #ffffff;
			// line-height: 22px;
			padding: 0 5px 0 0;
			float: left;
			&.fromChildren {
				font-size: 14px;
			}
			&.canClick {
      &:hover {
        color: #00D2FA;
      }
				cursor: pointer;
			}
		}
	}

	/* 新增适配小屏幕 */
	@media screen and (min-width: 1301px) and (max-width: 1480px) {
		#echarts-border {
			.border-header {
				.header-title {
					font-size: 0.1rem;
					padding-right: 0.05rem;
					padding-left: 0.05rem;
				}

				.select {
					&.class2 {
						.my-select {
							width: 0.55rem;
						}

						.my-select:first-child {
							width: 0.8rem;
						}

						.my-select:last-child {
							width: 0.8rem;
						}
					}

					.my-select {
						width: 0.55rem;

						&:last-child {
							width: 0.8rem;
						}
					}
				}
			}
		}
	}
	@media screen and (min-width: 900px) and (max-width: 1300px) {
		#echarts-border {
			.border-header {
				.header-title {
					font-size: 0.1rem;
					padding-right: 0.05rem;
					padding-left: 0.05rem;
					&.class2 {
						width: 1rem;
					}
				}

				.select {
					padding-right: 5px;

					&.class2 {
						.my-select:first-child {
							width: 0.8rem;
						}

						.my-select:last-child {
							width: 0.8rem;
						}
					}

					.my-select {
						width: 0.55rem;

						&:last-child {
							width: 0.8rem;
						}
					}
				}
			}
		}
	}

  @media screen and (max-width: 1440px) {
    .header-title {
       transform: scale(.9) translateX(-7px) translateY(-2px);
    }
  }

  @media screen and (min-width: 1500px) {
    #echarts-border .border-header .select.class2 .my-select:first-child {
      width: .7rem;
    }
  }
</style>
<style>
	.img-wapper {
		height: 0.36rem !important;
	}
</style>
